import FocusableNodeType from '../../../../Tree/Constants/FocusableNodeType';

const ComponentDisplayName = {
    [FocusableNodeType.GRID]: 'Grid',
    [FocusableNodeType.HORIZONTAL_LIST]: 'HorizontalList',
    [FocusableNodeType.VERTICAL_LIST]: 'VerticalList',
    [FocusableNodeType.VIRTUAL_HORIZONTAL_LIST]: 'VirtualHorizontalList',
    [FocusableNodeType.VIRTUAL_VERTICAL_LIST]: 'VirtualVerticalList',
    [FocusableNodeType.LEAF]: 'Leaf',
};

export default ComponentDisplayName;
